import { Grid } from '@material-ui/core';
import { LayoutConstants } from '../../../../theme/LayoutConstants';
import { LinkForm } from '../../../../components/link/form/LinkForm';
import { useParams } from 'react-router-dom';
import { useLinkQuery } from '../../../../graphql/models';
import { ApiRequestErrorAndLoadingWrapper } from '../../../../components/common/ApiRequestWrapper';
import { FormBreadCrumbs } from '../../../../components/common/navigation/breadcrumbs/FormBreadcrumbs';

export const EditLinkPage = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const numberId = Number(id);

  const { data, error, loading } = useLinkQuery({
    variables: { id: numberId },
  });

  return (
    <ApiRequestErrorAndLoadingWrapper error={error} loading={loading}>
      <Grid container spacing={LayoutConstants.gridSpacing}>
        <Grid item xs={12}>
          <FormBreadCrumbs translateLastPathName={data?.link === undefined} />
        </Grid>
        <Grid item xs={12}>
          <LinkForm link={data?.link} />
        </Grid>
      </Grid>
    </ApiRequestErrorAndLoadingWrapper>
  );
};
